import UnitMeasurements from ".";

export const unitMeasurementRoutes = [
  {
    path: "/unitsOfMeasurement",
    element: <UnitMeasurements />,
  },
];
